/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBoxContainer_viewer = {
    readonly username: string | null;
    readonly " $refType": "UserBoxContainer_viewer";
};
export type UserBoxContainer_viewer$data = UserBoxContainer_viewer;
export type UserBoxContainer_viewer$key = {
    readonly " $data"?: UserBoxContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBoxContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBoxContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'f7555c9da5834ab4d6582696a65b02dc';
export default node;
